import { render, staticRenderFns } from "./PrivacyModal.vue?vue&type=template&id=33649a47&scoped=true"
import script from "./PrivacyModal.vue?vue&type=script&lang=ts"
export * from "./PrivacyModal.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyModal.vue?vue&type=style&index=0&id=33649a47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33649a47",
  null
  
)

export default component.exports